
import { getEditLocation } from "../../../core/util/functions";
export const newsLocation = "/reports/news";
export const getNewsEditLocation = (id?: string) =>
 getEditLocation(newsLocation, undefined, id);

 export const editRouter = getNewsEditLocation(":newsId?");